/*
* Report page
*/

import * as React from 'react';
import * as _ from 'lodash';
import { Table } from 'react-bootstrap';

import * as ReportComponents from '../report-components';
import { Formatters } from '../../../common/formatters';
import * as ReportCommon from '../../report-common';

export const Render = ({ yearlySummaryType = ReportComponents.YearlySummaryTypes.recommendedValues, registerFunc, refFunc, scrollToFunc, maxTableRowsPerPage = 0, pageTitle = '', className = '', pageConfiguration, pageCount, reportData, ...rest }) => {
    let sectionName = ReportComponents.ReportSectionNames.yearlySummary;
    let rowKeyPrefix = 'rowChunk-ys-';
    let cellFieldNames = {
        ffb: 'h_ffb',
        rb: 'h_rb',
        pf: 'h_pf',
        rc: 'h_rc', // 20191004 Previous
        // rc: 'h_rcTotalWithSA',
        ii: 'h_ii',
        re: 'h_re',
        erb: 'h_erb',
        effb: 'h_effb',
    };

    // console.log(`yearlySummaryType ${yearlySummaryType}`, { cellFieldNames });
    switch (yearlySummaryType) {
        case ReportComponents.YearlySummaryTypes.currentValues:
            rowKeyPrefix = 'rowChunk-ys-current-';
            sectionName = ReportComponents.ReportSectionNames.yearlySummaryCurrent;
            cellFieldNames = {
                ffb: 'ffb',
                rb: 'rb',
                pf: 'pf',
                rc: 'rc',
                ii: 'ii',
                re: 're',
                erb: 'erb',
                effb: 'effb',
                // ffb: 'h_ffb',
                // rb: 'h_rb',
                // pf: 'h_pf',
                // rc: 'h_rc',
                // ii: 'h_ii',
                // re: 'h_re',
                // erb: 'h_erb',
            };
            break;

        case ReportComponents.YearlySummaryTypes.minimumValues:
            rowKeyPrefix = 'rowChunk-ys-min-';
            sectionName = ReportComponents.ReportSectionNames.yearlySummaryMinimum;
            cellFieldNames = {
                ffb: 'm_ffb',
                rb: 'm_rb',
                pf: 'm_pf',
                rc: 'm_rc',
                ii: 'm_ii',
                re: 'm_re',
                erb: 'm_erb',
                effb: 'm_effb',
            };
            break;

        case ReportComponents.YearlySummaryTypes.recommendedValues:
            rowKeyPrefix = 'rowChunk-ys-rec-';
            sectionName = ReportComponents.ReportSectionNames.yearlySummaryRecommended;
            cellFieldNames = {
                ffb: 'r_ffb',
                rb: 'r_rb',
                pf: 'r_pf',
                rc: 'r_rc',
                ii: 'r_ii',
                re: 'r_re',
                erb: 'r_erb',
                effb: 'r_effb',
            };
            break;

        default:
        case ReportComponents.YearlySummaryTypes.hypoValues:
            rowKeyPrefix = 'rowChunk-ys-';
            sectionName = ReportComponents.ReportSectionNames.yearlySummary;
            cellFieldNames = {
                ffb: 'h_ffb',
                rb: 'h_rb',
                pf: 'h_pf',
                rc: 'h_rc', // 20191004 Prev
                // rc: 'h_rcTotalWithSA',
                ii: 'h_ii',
                re: 'h_re',
                // erb: 'h_erb', // 20191004 Working
                erb: 'h_endingBalance',
                effb: 'h_effb',
            };
            break;
    }

    const ReportPageWithRegister = ReportComponents.withPageRegistration(ReportComponents.ReportPageHeaderFooter, sectionName, registerFunc, refFunc, scrollToFunc);
    const getRowKey = (id, tableName = 'data') => ReportComponents.getRowKey(id, sectionName, tableName);

    const chunkSize = (maxTableRowsPerPage > 0) ? maxTableRowsPerPage : _.get(pageConfiguration, 'maxTableRowsPerPage', 15);

    const { formData, association, calculations, isHypothetical, inventory, currentOrder, currentOrderChart, percentFunded, yearlySummaryData } = reportData;

    // const yearlySummaryDataCorrected = _.take(yearlySummaryData, Formatters.getInt(formData, 'calculateYears'));
    const yearlySummaryDataCorrected = _.take(yearlySummaryData, Formatters.getInt(formData, 'calculateYears', ReportCommon.CalculateYears));

    // console.log(`report-page-yearly-summary::render yearlySummaryType ${yearlySummaryType} sectionName ${sectionName} rowKeyPrefix ${rowKeyPrefix}`, { cellFieldNames, yearlySummaryDataCorrected, formData, reportData });

    const result = _(yearlySummaryDataCorrected)
        .chunk(chunkSize)
        .map((rowChunk, ind, arr) => (
            <div key={getRowKey(`${rowKeyPrefix}-${ind}`)}>
                <ReportPageWithRegister pageIndex={ind} title={pageTitle} className={className} totalPageCount={pageCount} showFooter={true} footerData={reportData}>
                    <div className="pdf-page-yearly-summary-table-container">
                        <Table condensed={true} bordered={true} responsive={false} className="pdf-data-table pdf-page-yearly-summary-table-group">
                            <thead>
                                <tr>
                                    <th>Year</th>
                                    <th>Beginning Fully Funded Balance</th>
                                    <th>Beginning Reserve Balance</th>
                                    <th>Beginning % Funded</th>
                                    <th>Reserve Contributions</th>
                                    <th>Interest Income</th>
                                    <th>Reserve Expenses</th>
                                    <th>Ending Reserve Balance</th>
                                    <th>Ending Fully Funded Balance</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    rowChunk.map((d, i) => (
                                        <tr key={getRowKey(`${rowKeyPrefix}-${ind}-tr-${i}`)}>
                                            <td className="text-center">{_.get(d, 'year')}</td>
                                            <td className="text-center"><ReportComponents.Currency value={Math.round(_.get(d, cellFieldNames.ffb))} decimals={0} /></td>
                                            <td className="text-center"><ReportComponents.Currency value={Math.round(_.get(d, cellFieldNames.rb))} decimals={0} /></td>
                                            <td className="text-center"><ReportComponents.Percentage value={_.get(d, cellFieldNames.pf)} decimals={0} /></td>
                                            <td className="text-center"><ReportComponents.Currency value={Math.round(_.get(d, cellFieldNames.rc))} decimals={0} /></td>
                                            <td className="text-center"><ReportComponents.Currency value={Math.round(_.get(d, cellFieldNames.ii))} decimals={0} /></td>
                                            <td className="text-center"><ReportComponents.Currency value={Math.round(_.get(d, cellFieldNames.re))} decimals={0} /></td>
                                            <td className="text-center"><ReportComponents.Currency value={Math.round(_.get(d, cellFieldNames.erb))} decimals={0} /></td>
                                            <td className="text-center">{(_.get(d, cellFieldNames.effb) === 0) ? 'END' : <ReportComponents.Currency value={_.get(d, cellFieldNames.effb)} decimals={0} />}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Table>
                    </div>
                </ReportPageWithRegister>
            </div>
        ))
        .value();

    return (
        <div>
            {result}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/report/pdf/pages/report-page-yearly-summary.tsx